import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  getAvailableDeployments,
  getSelectedDeploymentId,
  setSelectedDeployment,
  type Deployment,
} from "@/config/deployments";

const getEnvironmentColor = (environment: Deployment["environment"]) => {
  switch (environment) {
    case "production":
      return "bg-green-500";
    case "staging":
      return "bg-orange-500";
    case "development":
    default:
      return "bg-blue-500";
  }
};

export const DeploymentSwitcher = () => {
  const deployments = getAvailableDeployments();
  const currentId = getSelectedDeploymentId();
  const currentDeployment = deployments.find((d) => d.id === currentId);

  const handleChange = (newId: string) => {
    if (newId !== currentId) {
      setSelectedDeployment(newId);
      window.location.reload();
    }
  };

  return (
    <Select value={currentId} onValueChange={handleChange}>
      <SelectTrigger className="h-7 w-auto gap-1.5 border-none bg-muted/50 px-2 text-xs font-medium shadow-none hover:bg-muted focus:ring-0">
        <div className="flex items-center gap-1.5">
          <div
            className={`h-2 w-2 rounded-full ${getEnvironmentColor(currentDeployment?.environment || "development")}`}
          />
          <SelectValue />
        </div>
      </SelectTrigger>
      <SelectContent align="start">
        {deployments.map((deployment) => (
          <SelectItem key={deployment.id} value={deployment.id}>
            <div className="flex items-center gap-2">
              <div
                className={`h-2 w-2 rounded-full ${getEnvironmentColor(deployment.environment)}`}
              />
              <span>{deployment.name}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
